import { Chip as MuiChip, ChipProps as MuiChipProps, styled } from "@mui/material";

import { colors } from "../../utils/brand-colors";

// Extend MuiChipProps to accept any string for color
interface TagProps extends Omit<MuiChipProps, "color"> {
  color?: string;
}

const StyledTag = styled(MuiChip)(() => {
  return {
    borderRadius: "4px",
    height: "24px",
    fontSize: "0.75rem",
    fontWeight: 500,
    "& .MuiChip-label": {
      padding: "0 12px",
    },
  };
});

export const Tag: React.FC<TagProps> = ({ label, color, ...props }) => {
  // Check if color is a hex code (starts with #)
  const isHexColor = typeof color === "string" && color.startsWith("#");

  if (isHexColor) {
    return (
      <StyledTag
        label={label}
        sx={{
          backgroundColor: color,
          color: colors.white,
        }}
        {...props}
      />
    );
  }

  return <StyledTag label={label} {...props} />;
};

export default Tag;
